import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { fetchMyCampaigns, fetchStatusCount } from '@/features/campaigns/api/campaignApi';
import { queryKeys } from '@/shared/lib/query/queryKeys';

export type CampaignListFilters = {
  page?: number;
  limit?: number;
  search?: string;
  status?: string;
  startDate?: string;
  endDate?: string;
  agencyClientId?: string;
};

export function useMyCampaignsQuery(
  filters: CampaignListFilters,
  options?: { enabled?: boolean },
) {
  return useQuery({
    queryKey: queryKeys.campaigns.list(filters),
    queryFn: () => fetchMyCampaigns(filters),
    placeholderData: keepPreviousData,
    refetchOnWindowFocus: false,
    enabled: options?.enabled ?? true,
  });
}


// Get Status
export const useCampaignStatusQuery = () => {
  return useQuery({
    queryKey: ['campaign-status-count'],
    queryFn: fetchStatusCount,
    staleTime: 5 * 60 * 1000,
  });
};

